import { TimekeepingComponent } from "../../components";

export default function TimekeepingOnlineDataPage() {
  return <TimekeepingComponent.TimeKeepingOnlineDataList />;
}
